<div class="accepted_logos" *transloco="let t">
    <div class="accepted_title">
        <h3 class="accepted_title__header font_family__standard">{{t('accepted.payment.types')}}</h3>
    </div>
    <div class="accpt_pymnt__types">
        <ul class="align__payment_types_acptnc no-bullets" *ngIf="gd?.oscConfig?.ccPaymentEnabled">
            <li *ngIf="gd?.oscConfig?.visaEnabled && showCreditcardType('Visa')" tabindex="0" aria-label="Visa Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsvisa-copy.png" alt="Visa Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.masterCardEnabled && showCreditcardType('MasterCard')" tabindex="0" aria-label="MasterCard Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsmastercard-copy.png" alt="MasterCard Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.amexEnabled && showCreditcardType('Amex')" tabindex="0" aria-label="American Express Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsamex-copy.png" alt="American Express Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.discoverEnabled && showCreditcardType('Discover')" tabindex="0" aria-label="Discover Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsdiscover-copy.png" alt="Discover Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.jcbEnabled && showCreditcardType('JCB')" tabindex="0" aria-label="JCB Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsjcb-copy.png" alt="JCB Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.unionPayEnabled && showCreditcardType('UnionPay')" tabindex="0" aria-label="UnionPay Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsunionpay-copy.png" alt="UnionPay Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.dinersClubEnabled && showCreditcardType('Diners Club')" tabindex="0" aria-label="Diners Club Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsdinersclub-copy.png" alt="Diners Club Payment" />
            </li>
            <li *ngIf="gd?.oscConfig?.rupayGlobalEnabled && showCreditcardType('RuPay Global')" tabindex="0" aria-label="RuPay Payment Logo">
                <img class="pymnt_cc_amex_logo" src="../../assets/img/epms-payment-cardsrupay-copy.png" alt="RuPay Payment" />
            </li>
            <li *ngIf="paypalEnabled" tabindex="0" aria-label="PayPal Payment Logo">
                <!-- PayPal Logo -->
                <img class="pymnt_cc_amex_logo paypal_logo" src="../../assets/img/PP_Acceptance_Marks_for_LogoCenter_150x94.png" alt="PayPal Payment" />
                <!-- PayPal Logo -->
            </li>
        </ul>

        <!-- Alipay section -->
        <ul class="align__payment_types_acptnc no-bullets" *ngIf="alipayEnabled">
            <li tabindex="0" aria-label="Alipay+ Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_plus" src="../../assets/img/alipay/Alipayplus.png" alt="Alipay+" />
            </li>
            <li tabindex="0" aria-label="Alipay Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Alipay.png" alt="Alipay" />
            </li>
            <li tabindex="0" aria-label="Akulaku Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Akulaku.png" alt="Akulaku" />
            </li>
            <li tabindex="0" aria-label="Alipay Hong Kong Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Alipay_HK.png" alt="Alipay Hong Kong" />
            </li>
            <li tabindex="0" aria-label="Dana Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Dana.png" alt="Dana" />
            </li>
            <li tabindex="0" aria-label="G-Cash Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/G-cash.png" alt="G-Cash" />
            </li>
            <li tabindex="0" aria-label="Kakao Pay Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Kakao_Pay.png" alt="Kakao Pay" />
            </li>
            <li tabindex="0" aria-label="Kredivo Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Kredivo.png" alt="Kredivo" />
            </li>
            <li tabindex="0" aria-label="Rabbit Pay Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Rabbit_Pay.png" alt="Rabbit Pay" />
            </li>
            <li tabindex="0" aria-label="Touch N Go Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/Touch_N_Go.png" alt="Touch N Go" />
            </li>
            <li tabindex="0" aria-label="True Money Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_akulaku" src="../../assets/img/alipay/True_Money.png" alt="True Money" />
            </li>
            <li tabindex="0" aria-label="True Money Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_plus_naver" src="../../assets/img/alipay/Naverpay3.png" alt="NaverPay" />
            </li>
            <li tabindex="0" aria-label="True Money Payment Logo">
                <img class="pymnt_cc_amex_logo__alipay_plus_naver" src="../../assets/img/alipay/TossPay2.png" alt="TossPay" />
            </li>
        </ul>        
    </div>
</div>